/**
 * Retourne vrai s'il faut afficher le message demandant un accompte.
 */
export default function bookingEstimateHasAdvance({ bookingEstimate }) {
  return Boolean(bookingEstimate) && bookingEstimate.advanceAmount > 0;
}
